// 处理高德jscode
if (window) {
  window._AMapSecurityConfig = {
    // securityJsCode: process.env.VUE_APP_AmapSecret || '',
    serviceHost:'/_AMapService',
  }
}

import AMapLoader from '@amap/amap-jsapi-loader'
import { getSysType } from 'CommonUtils/plus.js'
import { judgeIosPermission } from './plus/permission.js'
import { gcj02tobd09 } from './convertGps.js'
import {getSysParameter} from 'Utils/publicApi'

import vm from '@/business/main'

var aMap = {}
AMapLoader.load({ //首次调用 load
  key: process.env.VUE_APP_AmapKey||'a459df13ad5d903e04c49241a3f88acb',//首次load key为必填
  version: '2.0',
}).then(AMap => {
  AMap.plugin('AMap.Geolocation', () => {
    // var geolocation = new AMap.Geolocation({
    // 	enableHighAccuracy: true,// 是否使用高精度定位，默认：true
    // 	timeout: 10000,         // 设置定位超时时间，默认：无穷大
    // 	noIpLocate: 1,
    // 	useNative: true,
    // })
    // Business.Geolocation=geolocation
  })
  aMap.AMap = AMap
  aMap.urlType = '0'
  console.log('loadamap bf : ', aMap)
  const webUrl = window.location.host
  console.log('loadamap webUrl',webUrl)
  getSysParameter('11605056').then(res=>{
    console.log('loadamap getSysParameter res : ' , res)
    console.log('loadamap getSysParameter includes : ' , res.value1.includes(webUrl))
    if(res.value1 && res.value1.includes(webUrl)){
      console.log('loadamap in ')
      aMap.urlType = '1'
    }
  })
  console.log('loadamap af : ', aMap)
}).catch((e) => {
  console.error(e)
})

aMap.load = (callback) => {
  AMapLoader.load({ //首次调用 load
    key: process.env.VUE_APP_AmapKey||'a459df13ad5d903e04c49241a3f88acb',//首次load key为必填
    version: '2.0',
  }).then(AMap => {
    AMap.plugin('AMap.Geolocation', () => {
      callback && callback()
    })
    aMap.AMap = AMap
  }).catch((e) => {
    console.error(e)
  })
}

/**
	* @desc 获取百度地理位置详细信息
	* @return {void}
	*/
aMap.Geocoder = function (location, callback) {
  if (location.coordsType == 'gcj02ll'||location.coordsType == 'gcj02') {
    var arr = gcj02tobd09(location.lng, location.lat)
    location.lng = arr[0]
    location.lat = arr[1]
    location.coordsType = 'bd09ll'
  } else if (location.coordsType == 'bd09ll') {
    1
  }
  /*console.log('调用百度接口geocoder',location)
	const webUrl = window.location.host
	console.log('调用百度接口webUrl',webUrl)
	let urlType = '0'
	 getSysParameter('11605056').then(res=>{
		console.log('Geocoder res : ' , res)
		console.log('Geocoder : ' , res.value1.includes(webUrl))
		if(res.value1 && res.value1.includes(webUrl)){
			console.log('Geocoder in ')
			urlType = '1'
		}
	})*/
  // 使用后端接口管控 原先方式弃用 2023年6月14日 15:14:17
  /*if(webUrl==='app.zhy.tmc.tianxiapiao.cn'){
    urlType = '1'
	}*/
  console.log('调用百度接口urlType',aMap.urlType)
  vm.$api['baidu/geocoder']({
    lat: location.lat,
    lng: location.lon||location.lng,
    coordType: location.coordsType,
    urlType: aMap.urlType
  }).then(res => {
    callback && callback(res)
  }).catch(err => {
    callback && callback(err)
  })
}

/**
* @desc 获取当前用户的所在位置信息
* @return {void}
*/
aMap.appGps = function () {
  return new Promise((resolve) => {
    if (getSysType() == 10504||getSysType() == 10505) {
      try {
        if (getSysType() == 10505) {
          var bool = judgeIosPermission('location') //判断iOS上是否给予位置权限，有权限返回true，否则返回false
          console.log('判断iOS上是否给予位置权限',bool)
          // plus.geolocation.watchPosition( function ( p ) {
          //     console.log( '监听位置变化信息:' )
          //     console.log( JSON.stringify(p) )
          // }, function ( e ) {
          //     console.log( '监听位置变化信息失败：'+e.message )
          // }, {'enableHighAccuracy':true,'geocode': false} )
          if (bool==false) {
            vm.$dialog.confirm({
              title: '提示',
              message: '权限没有开启，是否去开启？',
            }).then(() => {
              //确认，打开当前应用权限设置页面
              var UIApplication = plus.ios.import('UIApplication')
              var application2 = UIApplication.sharedApplication()
              var NSURL2 = plus.ios.import('NSURL')
              // var setting2 = NSURL2.URLWithString("prefs:root=LOCATION_SERVICES");
              var setting2 = NSURL2.URLWithString('app-settings:')
              application2.openURL(setting2)
              plus.ios.deleteObject(setting2)
              plus.ios.deleteObject(NSURL2)
              plus.ios.deleteObject(application2)
            }).catch(() => {
              vm.$dialog({message:'拒绝开启定位权限，将不能使用此功能！'})
            })
            resolve()
            return
          }
        }
        plus.geolocation.getCurrentPosition(function (res) {
          console.log('获取到GPS定位',res)
          resolve(res)
        }, function (e) {//定位失败回调
          console.log('gps 定位失败',e)
          aMap.amapGeolocation().then(point => {
            console.log('调用地图定位 point',point)
            resolve(point)
          })
          switch(e.code) {
            case e.PERMISSION_DENIED:
              vm.$dialog({ message: '您已拒绝获取定位，请开启定位重新获取！' })
              throw '您已拒绝获取定位，请开启定位重新获取！'
            case e.POSITION_UNAVAILABLE:
              vm.$dialog({message:'位置信息不可用！'})
              throw '位置信息不可用！'
            case e.TIMEOUT:
              vm.$dialog({message:'获取位置信息请求超时！'})
              throw '获取位置信息请求超时！'
            case e.UNKNOWN_ERROR:
              vm.$dialog({message:'获取位置信息失败！'})
              throw '获取位置信息失败！'
          }
          switch(e.code) {
            case -1501:
              vm.$dialog({message:'坐标地址解析失败！'})
              throw '坐标地址解析失败！'
            case -1502:
              vm.$dialog({message:'坐标地址获取失败！'})
              throw '坐标地址获取失败！'
            case -1503:
              vm.$dialog({message:'定位权限获取失败！'})
              throw '定位权限获取失败！'
            case -1504:
              vm.$dialog({message:'坐标系类型不支持！'})
              throw '坐标系类型不支持！'
            case -1505:
              vm.$dialog({message:'定位服务不能用！'})
              throw '定位服务不能用！'
          }
        }, {
          provider: 'amap'
        })
      } catch (e) {
        resolve()
        console.log('gps定位失败e',e)
        throw 'gps定位失败, 请手动选择城市！'
      }
    }	else {//高德jsapi定位
      var Geolocation=new aMap.AMap.Geolocation
      Geolocation.getCurrentPosition(function (status,result) {
        if (status == 'complete') {
          resolve({
            lng: result.position.lng,
            lat: result.position.lat,
            coordsType:'gcj02ll'
          })
        } if (status == 'error') {
          var obj={
            'NOT_SUPPORTED':'当前浏览器不支持定位功能 ',
            'FAILED':'地图定位失败',
          }
          if (obj[result.info]) {
            console.log(obj[result.info],result.message)
          } else {
            console.log(result.message)
          }
          resolve()
          throw '地图定位失败, 请手动选择城市！'
        }
      })
    }
  })
}

aMap.amapGeolocation = function () {
  return new Promise((resolve) => {
    //高德jsapi定位
    var Geolocation=new aMap.AMap.Geolocation
    Geolocation.getCurrentPosition(function (status,result) {
      if (status == 'complete') {
        resolve({
          lng: result.position.lng,
          lat: result.position.lat,
        })
      } if (status == 'error') {
        var obj={
          'NOT_SUPPORTED':'当前浏览器不支持定位功能 ',
          'FAILED':'定位失败',
        }
        if (obj[result.info]) {
          console.log(obj[result.info],result.message)
        } else {
          console.log(result.message)
        }
        throw '定位失败, 请手动选择城市！'
      }
    })
  })
}

aMap.getWeather=(cityName) =>{
  return new Promise((resolve) => {
    //加载天气查询插件
    aMap.AMap.plugin('AMap.Weather', function () {
      //创建天气查询实例
      var weather = new aMap.AMap.Weather()
      //执行实时天气信息查询
      weather.getLive(cityName, function (err, data) {
        resolve({ err, data })
      })
    })
  })
}

export default aMap
